// ============================================================================
// STATUS SERVICE
// ============================================================================
// API calls for common.tbl_status — used for UI dropdowns

import { get } from '../client/axiosClient';
import { statusEndpoints } from '../endpoints/commonStatuses.endpoints';
import type { ApiResponse, StatusDto } from '../types';

class StatusService {
  /** Get all statuses by type (e.g. 'GENERAL', 'APPROVAL'). Defaults to 'GENERAL'. */
  async getByType(statusType: string = 'GENERAL'): Promise<StatusDto[]> {
    const response = await get<ApiResponse<StatusDto[]>>(
      statusEndpoints.getByType(statusType)
    );
    return response.data.data;
  }
}

export const statusService = new StatusService();
export default statusService;
